import { render } from "./crm-contacts.vue?vue&type=template&id=497a251c&scoped=true"
import script from "./crm-contacts.vue?vue&type=script&lang=js"
export * from "./crm-contacts.vue?vue&type=script&lang=js"

import "./crm-contacts.vue?vue&type=style&index=0&id=497a251c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497a251c"]])

export default __exports__